export const swalConfig = {
  customClass: {
    container: "swal2-container-high-z",
    popup: "swal2-popup-high-z",
  },
};

export const convertSvgToFile = (svgString, fileName) => {
  if (!svgString) return null;
  const blob = new Blob([svgString], { type: "image/svg+xml" });
  return new File([blob], fileName, { type: "image/svg+xml" });
};

export const FREQUENCY_OPTIONS = [
  { value: "Daily", label: "Daily" },
  { value: "Custom", label: "Custom" },
];
